import { Injectable, Injector, Inject, forwardRef } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError, forkJoin, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AbstractService } from './abstract.service';
import { IDatasetPropertyDefinition } from 'app/interfaces/property-definition.interface';
import { AppService } from './app.service';
import { Router } from '@angular/router';

@Injectable()
export class DatasetService extends AbstractService{

	constructor(protected appService: AppService, protected http: HttpClient, protected router: Router){
		super(http, router);
	}

	get<T>(path: string, httpParams?: any, headers?: HttpHeaders): Observable<T>{
		return this.http.get<T>(this.appService.getBaseServerAddress() + path, {
			headers: headers,
			params: httpParams,
		}).pipe(
			catchError(this.handleError('dataset/get :> ' + path, false))
		);
	}

	post<T>(path: string, data?: any, options?: {}): Observable<T>{
		return this.http.post<T>(this.appService.getBaseServerAddress() + path, data, options).pipe(
			catchError(this.handleError('dataset/post :> ' + path, false))
		);
	}

	put<T>(path: string, data?: any): Observable<T>{
		return this.http.put<T>(this.appService.getBaseServerAddress() + path, data)
			.pipe(
				catchError(this.handleError('dataset/put :> ' + path))
			);
	}

	delete<T>(path: string): Observable<T>{
		return this.http.delete<T>(this.appService.getBaseServerAddress() + path)
			.pipe(
				catchError(this.handleError('dataset/delete :> ' + path))
			);
	}

	getPropertyDefinitions(datasetCode: string): Observable<any[]>{
		return this.http.get<IDatasetPropertyDefinition[]>(this.appService.getBaseServerAddress() + '/properties/definitions', {
			params: {
				dataset_code: datasetCode
			}
		}).pipe(
			catchError(this.handleError('GET /properties/definitions'))
		);
	}

	protected handleError(operations?: string, ignore: boolean = false): (errorResponse: HttpErrorResponse) => Observable<any>{
		const baseHanlder = super.handleError(operations, ignore);

		return (errorResponse: HttpErrorResponse) => {
			if(errorResponse.status >= 400 && errorResponse.status < 500){
				if(errorResponse.error){
					console.error('unhandled error', errorResponse.error);
				}
			}
			return baseHanlder(errorResponse);
		};
	}
}
